import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PageLiveChatComponent } from '../../../pages/account/pages/page-live-chat/page-live-chat.component';

@Component({
    selector: 'app-chat-modal',
    templateUrl: './chat-modal.component.html',
    styleUrls: ['./chat-modal.component.scss'],
    standalone: true,
    imports: [PageLiveChatComponent]
})
export class ChatModalComponent implements OnInit {
    @Input() chatId: String;

    constructor(
        public bsModalRef: BsModalRef
    ) {}

    ngOnInit(): void {
    }
}
